<script setup>
defineProps({
  data: Object
})
const { altFallback } = usePageAltFallback();
const getOverlayImageAlt = (image) =>
  resolveMediaAlt(image, altFallback.value, 'Image');
</script>

<template>
  <div class="block content-gradient-image-overlay">
    <section class="content-section" :class="(data?.backgroundColor ? 'bg-' + String(data.backgroundColor).toLowerCase().replace(/\s+/g, '-') : 'bg-white')">
      <div class="container">
        <div class="row align-items-start justify-content-center">
          <div class="col-12">
            <h2 class="component-title" v-html="data?.heading" :class="data?.displayGradient ? 'component-title-gradient' : ''"></h2>
          </div>
          <div v-for="(column, columnIndex) in (Array.isArray(data?.columns) ? data.columns : [])" :key="columnIndex" class="col-12 col-lg-4">
            <article class="column-content" v-html="column?.content"></article>
          </div>
        </div>
      </div>
    </section>
    <section class="images-section">
      <div class="container images-container">
        <div class="row align-items-center justify-content-around">
          <div v-for="(image, imageIndex) in (Array.isArray(data?.images?.data) ? data.images.data : [])" :key="image?.id || image?.attributes?.url || imageIndex" class="col text-center">
            <img v-if="image?.attributes?.url"
              class="image-item"
              :src="image?.attributes?.url"
              :alt="getOverlayImageAlt(image)"
              loading="lazy"
              decoding="async"
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
  .content-gradient-image-overlay{
    .content-section{
      padding-bottom: 50px;
      padding-top: 60px;
      .component-title {
        text-align: center;
        margin-bottom: 40px;
      }
    }
    .images-section{
      .images-container{
        border-radius: 24px;
        position: relative;
        top: -40px;
        margin-bottom: -40px;
        background: $color-secondary;
        .image-item{
          margin: 20px;
          max-width: 160px;
          max-height: 160px;
        }
      }
    }

    @include media-breakpoint-up(lg) {
      .content-section{
        padding-bottom: 100px;
      }
      .images-section{
        .images-container{
          top: -80px;
          margin-bottom: -80px;
          padding: 30px;
          .image-item{
            margin: 30px;
          }
        }
      }
    }
  }
</style>